import React from "react";

const PageHeader = ({ eyebrow, title, subtitle, image }) => {
  return (
    <section data-testid="page-header" className="relative bg-ink text-white overflow-hidden">
      {image && (
        <>
          <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-ink" />
        </>
      )}
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 pt-28 pb-20 lg:pt-36 lg:pb-28">
        {eyebrow && <div className="overline text-brand mb-5">{eyebrow}</div>}
        <h1 className="font-heading font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight max-w-4xl leading-[1.05]">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-6 text-steel-300 text-base sm:text-lg max-w-2xl leading-relaxed">{subtitle}</p>
        )}
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brand to-transparent" />
    </section>
  );
};

export default PageHeader;
